import React, { memo } from "react";
import {
  MessageFragment,
  MessageThreadFragment,
  MessageType,
} from "gql/graphql";
import { Box, HStack, VStack, Text } from "@chakra-ui/react";
import MessageUserNameDateHeader from "modules/messaging/messages/message-user-name-date-header";
import colors from "app/colors";
import { useAuth } from "modules/providers/auth-provider";
import CircularCheckbox from "modules/_shared/buttons/circular-checkbox";
import { ICheckboxProps } from "modules/utils/Constants";
import { canForwardMessage } from "modules/utils/Functions";
import ReadonlyMessageBody from "modules/messaging/messages/readonly-message-body";

interface IProps {
  messageThread: MessageThreadFragment;
  message: MessageFragment;
  checkboxProps: ICheckboxProps;
}

const ForwardToMessage = ({
  messageThread,
  message,
  checkboxProps,
}: IProps) => {
  const { me } = useAuth();
  const bottomPadding = 4;

  if (message.type === MessageType.Task) {
    return (
      <HStack alignItems="flex-start" spacing={0} pb={bottomPadding} px={3}>
        <VStack
          alignItems="flex-start"
          spacing={0}
          w="full"
          borderColor={colors.grayPrimary}
          borderWidth={1}
          borderRadius={8}
        >
          <HStack w="full" pl={2} pt={2}>
            {canForwardMessage(message) && (
              <CircularCheckbox {...checkboxProps} />
            )}
            <Text fontSize={16} fontWeight={600} color={colors.blackSecondary}>
              Task Description
            </Text>
          </HStack>
          <ReadonlyMessageBody
            messageThread={messageThread}
            message={message}
            overrideMessageBackgroundColor={colors.white}
          />
        </VStack>
      </HStack>
    );
  }

  return (
    <HStack alignItems="flex-start" spacing={0} pb={bottomPadding} px={3}>
      <VStack alignItems="flex-start" spacing={0} w="full">
        <HStack w="full" alignItems="start" spacing={0}>
          <Box
            w="52px"
            backgroundColor={
              message.createdUserId === me?.id
                ? colors.messageBackgroundSelf
                : colors.messageBackground
            }
          >
            <Box
              backgroundColor={colors.white}
              borderColor={colors.white}
              borderWidth={8}
              borderBottomLeftRadius={20}
              h="48px"
            >
              {canForwardMessage(message) && (
                <CircularCheckbox {...checkboxProps} />
              )}
            </Box>
          </Box>
          <MessageUserNameDateHeader message={message} />
        </HStack>
        <ReadonlyMessageBody messageThread={messageThread} message={message} />
      </VStack>
    </HStack>
  );
};

export default memo(ForwardToMessage);
